<template>
  <div class="wrapper">
    <Navbar />
    <Header />
    <RouterView />
    <Footer />
  </div>
</template>

<script>

import Footer from '@/partials/Footer'
import Header from '@/partials/Header'
import Navbar from '@/partials/Navbar'

export default {
  name: 'Primary',
  components: {
    Navbar,
    Header,
    Footer
  }
}
</script>

<style scoped>

</style>
